export const host ="https://koshurprinters.onrender.com";
// export const host ="http://localhost:5000";
export const registerRoute=`${host}/api/auth/register`;
export const loginRoute=`${host}/api/auth/login`;
